import {
  type EnvironmentProviders,
  makeEnvironmentProviders,
  provideEnvironmentInitializer,
} from '@angular/core';
import { type FeatureFlag, FeatureFlags } from '@tvd/utils/feature-flags';
import { installFeatureFlagConsole, readFlagOverride } from './flag-overrides';
import { PostHogService } from './posthog.service';

/**
 * Binds the `FeatureFlags` token to PostHog, with a dev-only console override
 * layer in front (see `flag-overrides.ts`). Every flag read passes through
 * `readFlagOverride` first, so a developer can force any flag on non-prod
 * builds; otherwise PostHog decides.
 */
export const provideFeatureFlags = (): EnvironmentProviders =>
  makeEnvironmentProviders([
    {
      provide: FeatureFlags,
      useFactory: (posthog: PostHogService) => ({
        isFeatureEnabled: (feature: FeatureFlag): boolean => {
          const override = readFlagOverride(feature);
          return Boolean(override ?? posthog.isFeatureEnabled(feature));
        },
      }),
      deps: [PostHogService],
    },
    provideEnvironmentInitializer(() => installFeatureFlagConsole()),
  ]);
